import React from "react";
import "./css/Addminister.css";
import member1 from "../Component/Images/shekhar.jpg"; 
import member2 from "../Component/Images/sachin.jpg";
import member3 from "../Component/Images/rajendra.jpg"
import member4 from "../Component/Images/bade.jpg"
import member5 from "../Component/Images/shankar.jpg"
import member6 from "../Component/Images/umesh.jpg"
import member7 from "../Component/Images/suresh.jpg"
export default function AdministrationSection() {
  return (
    <section className="admin-section">
      <h2 className="admin-title">ग्रामपंचायत प्रशासन</h2>

      <div className="admin-grid">

        <div className="admin-card">
          <img src={member1} alt="Sarpanch" className="admin-photo" />

          <h3 className="admin-name">श्री. शेखर मानसिंग ताटे</h3>
          <p className="admin-position">क्लार्क</p>
        </div>

        {/* Card 2 */}
        <div className="admin-card">
          <img src={member2} alt="Up-Sarpanch" className="admin-photo" />

          <h3 className="admin-name">श्री. सचिन हणमंत राक्षे</h3>
          <p className="admin-position">शिपाई</p>
        </div>

         <div className="admin-card">
          <img src={member3} alt="Up-Sarpanch" className="admin-photo" />

          <h3 className="admin-name">श्री. राजेंद्र बाजीराव भोसले</h3>
          <p className="admin-position">पा. पु कर्मचारी तासगांव</p>
        </div>
         <div className="admin-card">
          <img src={member4} alt="Up-Sarpanch" className="admin-photo" />

          <h3 className="admin-name">श्री. मधुकर रामचंद्र बडे</h3>
          <p className="admin-position">पा. पु कर्मचारी मुळीकवाडी </p>
        </div>

 <div className="admin-card">
          <img src={member5} alt="Up-Sarpanch" className="admin-photo" />

          <h3 className="admin-name">श्री. शंकर दिनकर धोंडवड</h3>
          <p className="admin-position">पा. पु कर्मचारी धोंडेवाडी  </p>
        </div>

 <div className="admin-card">
          <img src={member6} alt="Up-Sarpanch" className="admin-photo" />

          <h3 className="admin-name">श्री. उमेश नवनाथ लवळे</h3>
          <p className="admin-position">पा. पु कर्मचारी ब्राम्हणवाडी  </p>
        </div>
        <div className="admin-card">
          <img src={member7} alt="Up-Sarpanch" className="admin-photo" />

          <h3 className="admin-name">श्री. सुरेश सर्जेराव भोसले</h3>
          <p className="admin-position">पा. पु कर्मचारी भोसलेवाडा</p>
        </div>



      </div>
    </section>
  );
}
